import { supertypeClass, property } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { Party } from './Party';
import { Policy } from './Policy';

@supertypeClass({ toClient: true, toServer: true })
export class Owner extends Everything {
  @property({ getType: () => Policy })
  policy: Policy;

  @property({ comment: 'Reference to the party for the owner which can be Person or Entity' })
  party: Party;

  @property({
    values: ['you', 'spouse', 'partnerfiance'],
    descriptions: { you: 'Yes', spouse: 'No, my spouse', partnerfiance: 'No, my partner or fiance' },
    comment: 'How does the owner relate to the insured? For example spouse if owner is different from insured.',
  })
  relationshipToInsured: string;

  @property({
    rule: ['required'],
    values: ['insured', 'ownerEstate'],
    descriptions: { insured: 'Insured', ownerEstate: "Owner's Estate" },
    comment: 'Who should ownership of the policy be transferred to if the owner dies?',
  })
  ownerDelegate: string;

  constructor() {
    super();
  }

  static new() {
    return new Owner().init();
  }

  init() {
    return this;
  }
}
